import { useConcept, useConceptActivation } from '../../../redux/selectConcept'
import L1ErrorBlock from '../l1/L1ErrorBlock'
import L3JumpButton from '../l3/L3JumpButton'
import { L4NoPrint } from './L4Print'

interface L4JumpButtonProps {
	cid?: string
	jumpCid?: string
	direction?: 'left'|'right'
	title?: string
}

const L4JumpButton = ({cid, jumpCid, direction = 'right', title = 'Jump'}: L4JumpButtonProps) => {
	const activation = useConceptActivation(cid)
	const jumpConcept = useConcept(jumpCid)
	if(!jumpConcept) {
		return <L1ErrorBlock content={`[L4JumpButton] concept for jumpCid ${jumpCid} not found`} />
	}
	return (
		<L4NoPrint>
			<L3JumpButton
				activation={activation}
				jumpConcept={jumpConcept}
				direction={direction}
				title={title}
			/>
		</L4NoPrint>
	)
}

export default L4JumpButton
